module.exports = __webpack_public_path__ + "img/JPME_80X30.108c16e8.png";